// extracted by mini-css-extract-plugin
module.exports = {"close-btn":"dialog-close-button_close-btn__k94xu"};